import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class PrintNode_ds_printQueue_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList($inParams: { fullTextSearch?: string, $top?: number, $skip?: number }): Promise<{ result?: { id?: string, printer_id?: number, title?: string, contentType?: string, content?: string, source?: string, batchNumber?: number, printSequence?: number, printed?: boolean, locked?: boolean, retry?: number, reference?: string }[], totalCount?: number }> {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { fullTextSearch?: string, $keys: string[] }): Promise<{ result?: { id?: string, printer_id?: number, title?: string, contentType?: string, content?: string, source?: string, batchNumber?: number, printSequence?: number, printed?: boolean, locked?: boolean, retry?: number, reference?: string }[] }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      fullTextSearch?: string    }) {
      return false;
    }
}
